let audio: AudioContext | null = null;
let noise: AudioBuffer | null = null;
// Same 40 ms, band-pass mechanical key-strike voice as the prototype. Called only
// from a real user key event; browser audio restrictions never block the form.
export function playAuthKeySound() {
  try {
    if (typeof AudioContext === 'undefined') return;
    audio ??= new AudioContext();
    if (audio.state === 'suspended') void audio.resume().catch(() => undefined);
    if (!noise) {
      noise = audio.createBuffer(1, Math.floor(audio.sampleRate * 0.04), audio.sampleRate);
      const data = noise.getChannelData(0);
      for (let i = 0; i < data.length; i++)
        data[i] = (Math.random() * 2 - 1) * Math.exp(-i / (data.length * 0.18));
    }
    const source = audio.createBufferSource();
    const band = audio.createBiquadFilter();
    const gain = audio.createGain();
    source.buffer = noise;
    band.type = 'bandpass';
    band.frequency.value = 2600 + Math.random() * 600;
    band.Q.value = 1.4;
    gain.gain.value = 0.55;
    source.connect(band);
    band.connect(gain);
    gain.connect(audio.destination);
    source.start(audio.currentTime);
    source.onended = () => {
      source.disconnect();
      band.disconnect();
      gain.disconnect();
    };
  } catch {
    /* Decorative sound is optional; authentication is not. */
  }
}

export function stopAuthKeySound() {
  if (audio) void audio.close().catch(() => undefined);
  audio = null;
  noise = null;
}
